module.exports = __webpack_public_path__ + "img/0Q3A3494_L_Wood_MockedUp.2e207692.jpg";